window.bundleRunning = false;

function removeOrphanEngravings(cart) {
  if (window.bundleRunning) return;
  if (!cart || !cart.items || !cart.items.length) return;
  window.bundleRunning = true;

  let updates = {};

  cart.items.forEach(item => {
    const props = item.properties || {};
    const hasBundle = !!props._bundle;
    const isEngraving = item.title && item.title.includes('Engraving Letters');

    if (hasBundle && isEngraving) {
      const bundleKey = props._bundle;

      const matchedParent = cart.items.find(otherItem => {
        if (otherItem.key === item.key) return false;
        const otherProps = otherItem.properties || {};
        return (
          otherProps._bundle === bundleKey &&
          !(otherItem.title && otherItem.title.includes('Engraving Letters'))
        );
      });

      if (!matchedParent) {
        updates[item.key] = 0;
      }
    }
  });

  if (Object.keys(updates).length) {
    // Esto se ejecuta en “background”, nunca bloquea el proceso de render ni el ciclo de UpCart
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    }).catch(e => {
      console.error("Failed to update cart:", e);
    }).finally(() => {
      window.bundleRunning = false;
    });
  } else {
    window.bundleRunning = false;
  }
}

// Handlers SIN async/SIN await
window.upcartModifyCart = function(cart) {
  removeOrphanEngravings(cart);
  return cart;
};

window.upcartOnCartUpdated = function(cart) {
  removeOrphanEngravings(cart);
  return cart;
};

window.upcartOnCartLoaded = function(cart) {
  removeOrphanEngravings(cart);
  return cart;
};

